<script setup>
    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    });
</script>

<template>
    <div class="title" :style="{'padding-top': props.data.margin + 'px','padding-bottom': props.data.margin + 'px',backgroundColor: props.data.background_color}">
        <div v-if="props.data.style == 1" class="title-style1" :style="{ color: props.data.title_color }">
            <div class="title-content" :class="{ 'title-content-line': props.data.title_line }">
              <span :style="{ 'font-size': props.data.title_font_size + 'px' }">{{ props.data.title }}</span>
            </div>
        </div>

        <div v-if="props.data.style == 2" class="title-style2">
            <div class="title-content" :style="{color: props.data.title_color,'font-size': props.data.title_font_size + 'px'}">
                {{ props.data.title }}
            </div>
            <div v-if="props.data.is_more" class="title-more" :style="{ color: props.data.more_color,'font-size': props.data.more_font_size + 'px'}">
                {{ props.data.moretitle }} <el-icon :size="props.data.more_font_size"><ArrowRight /></el-icon>
            </div>
            <div v-if="props.data.is_subtitle" class="title-subtitle" :style="{color: props.data.subtitle_color,'font-size': props.data.subtitle_font_size + 'px'}">
                {{ props.data.subtitle }}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.title {
  .title-style1,.title-style2 {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    position: relative;
  }

  .title-style2 {
    .title-content {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }

    .title-more {
      position: absolute;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      right: 16px;
      top: 0;
      height: 100%;
      line-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .title-subtitle {
      margin-top: 4px;
      font-size: 12px;
      height: 20px;
      font-weight: 400;
      color: #333333;
    }
  }

  .title-style1 {
    text-align: center;

    .title-content-line:before {
      display: inline-block;
      content: '';
      width: 15%;
      height: 5px;
      border-top: 1px solid #898989;
      margin-right: 10px;
    }

    .title-content-line:after {
      display: inline-block;
      content: '';
      width: 15%;
      height: 5px;
      border-top: 1px solid #898989;
      margin-left: 10px;
    }
  }
}

</style>